import axios from "axios";

// I körning används sidans egen domän (frontend + backend delar alltid domän
// via /api-routing) — så fungerar fil-länkar och API-anrop även om appen körs
// på en annan domän än den som bakades in vid bygget (t.ex. custom domain).
// Fallback till env-variabeln för lokal dev (http://localhost:3000 → :8001).
const sameOrigin =
  typeof window !== "undefined" && /^https:\/\//.test(window.location.origin);
const BASE = sameOrigin ? window.location.origin : process.env.REACT_APP_BACKEND_URL;
export const API_BASE = BASE;
export const API = `${BASE}/api`;

// Default-timeout 90s — backend kan timeouta tyst (k8s ingress, LLM-anrop) och
// då hänger UI-spinners för evigt. För långa LLM-genereringar (quiz, summary)
// kan callern höja timeout per-request via `{ timeout: 180000 }`.
export const api = axios.create({ baseURL: API, timeout: 90_000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("grindstugatan_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("grindstugatan_token");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  },
);

export const setToken = (t) => {
  if (t) localStorage.setItem("grindstugatan_token", t);
  else localStorage.removeItem("grindstugatan_token");
};

/**
 * Build a clickable URL for an attachment. Proxied URLs (from our backend
 * for Drive files belonging to a student account) need the token appended
 * so that the browser can authenticate when opening in a new tab.
 */
export const resolveAttachmentUrl = (url) => {
  if (!url) return "#";
  // Already absolute (drive.google.com, docs.google.com, youtube…) — open as-is
  if (/^https?:\/\//i.test(url)) return url;
  // Backend-proxy path — prepend BASE and append token
  if (url.startsWith("/api/")) {
    const token = localStorage.getItem("grindstugatan_token");
    const sep = url.includes("?") ? "&" : "?";
    return `${BASE}${url}${token ? `${sep}token=${encodeURIComponent(token)}` : ""}`;
  }
  return url;
};
